export default __webpack_public_path__ + "static/media/qrcode.60eeffca.jpg";